import requester from 'utils/requester';
import { CONTENT_TYPES } from 'constants/content-types';
import api from 'config/api';
import { IRequesterResponse, BannerType, DetailsObjectType, ChannelType } from './loader-types';

const loadBanners = async () => {
  const id = 'BANNERS' as const;
  const contentType = CONTENT_TYPES.BANNER;
  const { data: banners } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.ads}`,
    params: {
      $expand: 'pictures(url),tags',
      'tags[in]': 'screen:home',
    },
  })) as IRequesterResponse<BannerType[]>;
  // It removes banners with extarnal link because smartTv doesn't support it
  const data = banners.filter((banner) => !banner.url.startsWith('http'));

  return { id, data, contentType };
};

const loadContinueWatch = async () => {
  const id = 'CONTINUE_WATCH' as const;
  const contentType = CONTENT_TYPES.VOD_ASSET;
  const title = 'Continue';

  const { data } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.assets}`,
    params: {
      'type[in]': 'movie',
      $expand: 'genres,persons,resources(url),entitlement,bookmark,packages',
      'bookmark[eq]': 1,
      $orderby: 'bookmark_update_time',
      $limit: 20,
      $offset: 0,
    },
  })) as IRequesterResponse<DetailsObjectType[]>;

  return { id, data, contentType, title };
};

const loadChannels = async () => {
  const id = 'TV_CHANNELS' as const;
  const contentType = CONTENT_TYPES.CHANNEL;
  const title = 'TV';
  const { data } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.assets}`,
    params: {
      'type[eq]': 'channel',
      $expand: 'resources(url),entitlement,favorite,bookmark,packages',
      $orderby: 'lcn',
      $limit: 25,
      $offset: 0,
    },
  })) as IRequesterResponse<ChannelType[]>;

  return { id, data, contentType, title };
};

const loadVideo = async () => {
  const id = 'VIDEO';
  const contentType = CONTENT_TYPES.VOD_ASSET;
  const title = 'Video';
  const { data } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.assets}`,
    params: {
      'type[in]': 'movie,series,cartoons',
      'categories.ext_id[neq]': 'cardi',
      $expand: 'resources(url),entitlement,favorite,bookmark,packages',
      $orderby: '-year',
      $limit: 20,
      $offset: 0,
    },
  })) as IRequesterResponse<DetailsObjectType[]>;

  return { id, data, contentType, title };
};

export const homePageLoader = async (_params) => {
  const result = await Promise.allSettled([
    loadBanners(),
    loadContinueWatch(),
    loadChannels(),
    loadVideo(),
  ]);

  return result
    .map((p) => (p.status === 'fulfilled' ? p : null))
    .filter((p) => p)
    .map((p) => p.value)
    .filter((v) => v.data.length > 0);
};

export default homePageLoader;
